import i18next from 'i18next';
import $ from "jquery";

export class GPTranslations {

    constructor() {
        this.i18n = i18next;
    };

    t(key, message, defVal) {
        return this.i18n.t(key + '.' + message, {defaultValue: defVal?defVal:message})
    };

    initialize() {
        let that = this;
        return new Promise(function (resolve, reject) {
            var lang = GPSettings.language();
            $.ajax({
                dataType: "json",
                url: 'locales/' + lang + '.json?v=__VERSION__',
                success: function (trans) {
                    var settings = {
                        lng: lang,
                        resources: {}
                    };
                    settings.resources[lang] = {"translation": trans};
                    that.i18n.init(settings, resolve);
                }
            });
        })
    }

}

let instance;

export async function initTranslator() {
    if (instance)
        return instance;
    else {
        instance = new GPTranslations();
        await instance.initialize();
        return instance;
    }
}

export function getGPTransFunc(area) {
    return (message) => {
        return instance.t(area, message);
    }
}